import { render, staticRenderFns } from "./txnDetail.vue?vue&type=template&id=e2eaf640&scoped=true&"
import script from "./txnDetail.vue?vue&type=script&lang=js&"
export * from "./txnDetail.vue?vue&type=script&lang=js&"
import style0 from "./txnDetail.vue?vue&type=style&index=0&id=e2eaf640&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2eaf640",
  null
  
)

export default component.exports